<div class="helpbutton">
  <button mat-icon-button (click)="goToDoc()">
    <mat-icon aria-label="Helper icon-button with a help icon">help</mat-icon>
  </button>
</div>
